import type { ReactNode } from 'react';

import { AppSectionHero, type AppSectionHeroStat } from '../../ui-foundation';

export default function SectionHeroCard({
  title,
  subtitle,
  stats,
  action,
  actions = [],
}: {
  title: string;
  subtitle: string;
  stats: AppSectionHeroStat[];
  action?: ReactNode;
  actions?: Array<{ label: string; onClick: () => void; primary?: boolean }>;
}) {
  void actions;
  return <AppSectionHero title={title} subtitle={subtitle} stats={stats} action={action} />;
}
